import * as Yup from 'yup';
import { validateSocialNetworkUrl, validateUrl } from 'shared/utils';

export default Yup.object().shape({
  website: Yup.string().test('is-valid-url', 'Некорректный URL', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const result = validateUrl(value);
    return result.isValid ? true : this.createError({ message: result.errorMessage || 'Некорректный URL' });
  }),
  vk: Yup.string().test('is-valid-vk', 'Некорректная ссылка ВКонтакте', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const urlResult = validateUrl(value);
    if (!urlResult.isValid) {
      return this.createError({
        message: urlResult.errorMessage || 'Некорректная ссылка ВКонтакте',
      });
    }

    const socialResult = validateSocialNetworkUrl(value, 'vk');
    return socialResult.isValid
      ? true
      : this.createError({
          message: socialResult.errorMessage || 'Некорректная ссылка ВКонтакте',
        });
  }),
  'vk-video': Yup.string().test('is-valid-vk-video', 'Некорректная ссылка ВКвидео', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const urlResult = validateUrl(value);
    if (!urlResult.isValid) {
      return this.createError({
        message: urlResult.errorMessage || 'Некорректная ссылка ВКвидео',
      });
    }

    const socialResult = validateSocialNetworkUrl(value, 'vk-video');
    return socialResult.isValid
      ? true
      : this.createError({
          message: socialResult.errorMessage || 'Некорректная ссылка ВКвидео',
        });
  }),
  telegram: Yup.string().test('is-valid-telegram', 'Некорректная ссылка Telegram', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const urlResult = validateUrl(value);
    if (!urlResult.isValid) {
      return this.createError({
        message: urlResult.errorMessage || 'Некорректная ссылка Telegram',
      });
    }

    const socialResult = validateSocialNetworkUrl(value, 'telegram');
    return socialResult.isValid
      ? true
      : this.createError({
          message: socialResult.errorMessage || 'Некорректная ссылка Telegram',
        });
  }),
  youtube: Yup.string().test('is-valid-youtube', 'Некорректная ссылка YouTube', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const urlResult = validateUrl(value);
    if (!urlResult.isValid) {
      return this.createError({
        message: urlResult.errorMessage || 'Некорректная ссылка YouTube',
      });
    }

    const socialResult = validateSocialNetworkUrl(value, 'youtube');
    return socialResult.isValid ? true : this.createError({ message: socialResult.errorMessage || 'Некорректная ссылка YouTube' });
  }),
  instagram: Yup.string().test('is-valid-instagram', 'Некорректная ссылка Instagram', function (value) {
    if (!value) {
      return true;
    } // Allow empty value
    const urlResult = validateUrl(value);
    if (!urlResult.isValid) {
      return this.createError({
        message: urlResult.errorMessage || 'Некорректная ссылка Instagram',
      });
    }

    const socialResult = validateSocialNetworkUrl(value, 'instagram');
    return socialResult.isValid
      ? true
      : this.createError({
          message: socialResult.errorMessage || 'Некорректная ссылка Instagram',
        });
  }),
});
